module.exports = __webpack_public_path__ + "img/showshare.2ded4ed5.png";